import React, { useEffect, useRef } from "react";
import Routes from "./Routes";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import FloatingDavid from "./components/FloatingDavid";
import useIsMobile from "./hooks/useIsMobile";

function FounderCallWidget() {
  const location = useLocation();
  const isMobile = useIsMobile();
  return location.pathname.startsWith("/demo/") || isMobile
    ? null
    : <FloatingDavid />;
}

function GoogleAnalyticsTracker() {
  const location = useLocation();
  const hasTrackedInitialPage = useRef(false);

  useEffect(() => {
    if (typeof window.gtag !== "function") {
      return;
    }

    if (!hasTrackedInitialPage.current) {
      hasTrackedInitialPage.current = true;
      return;
    }

    window.gtag("event", "page_view", {
      page_path: `${location.pathname}${location.search}${location.hash}`,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

function App() {
  return (
    <Router>
      <GoogleAnalyticsTracker />
      <Routes />
      <FounderCallWidget />
    </Router>
  );
}

export default App;
